export const STORY_STATUS_VALUES = ["draft", "published", "archived"];
export const StoryStatus = {
    DRAFT: "draft",
    PUBLISHED: "published",
    ARCHIVED: "archived",
};
